"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OldOrcishWaysEffectHandler = exports.OldOrcishWaysEffectArgs = void 0;
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class OldOrcishWaysEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.OldOrcishWays;
        this.__typeName = "OldOrcishWays";
        this.name = "Old Orcish Ways";
        this.harmful = false;
    }
}
exports.OldOrcishWaysEffectArgs = OldOrcishWaysEffectArgs;
let OldOrcishWaysEffectHandler = class OldOrcishWaysEffectHandler {
    apply(sequence, container, state) {
        state.meta.ehId = container.registerEventHandlerScript(state.targetId, state.targetId, Schedule_1.Schedule.Unlimited, "Ability_OldOrcishWays_OnDamaged", {});
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.ehId);
    }
};
OldOrcishWaysEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.OldOrcishWays)
], OldOrcishWaysEffectHandler);
exports.OldOrcishWaysEffectHandler = OldOrcishWaysEffectHandler;
